const CicSaveReasonModalTestIdsScope = {
  CIC_SAVE_REASON_MODAL: 'cic-save-reason-modal',
};

export const CicSaveReasonModalTestIds = {
  CIC_SAVE_REASON_MODAL_CONTENT: `${CicSaveReasonModalTestIdsScope.CIC_SAVE_REASON_MODAL}.content`,
  CIC_SAVE_REASON_MODAL_NOTE_INPUT: `${CicSaveReasonModalTestIdsScope.CIC_SAVE_REASON_MODAL}.note-input`,
};
